// extracted by mini-css-extract-plugin
module.exports = {"gallery":"style_gallery__u5nMu","gallerySquare":"style_gallerySquare__eu7gX"};